import { Fragment, useRef, useState } from 'react';
import { Box, Grid, Stack } from '@mui/material';

import Form from 'components/Form';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';
import RowContentPreWrap from './components/RowContentPreWrap';
import SectionTitle from '../../components/SectionTitle';
import MuiRadioGroup from './components/MuiRadioGroup';
import { DateBoundTimePicker } from 'components/TimePicker/DateBoundTimePicker';
import { coercePickerDate } from 'utils/timePickerBridge';

interface Props extends IFormRegister, IFormValues, IFormWatch {
  disabled?: boolean;
  restraintList: string[];
  setRestraintList: (restraintList: string[]) => void;
}

const symptoms = [
  {
    label: '혼돈 / 방향 감각 상실',
    key: 'apply.symptoms.check0',
  },
  {
    label: '자해',
    key: 'apply.symptoms.check1',
  },
  {
    label: '다른 / 주위 환경에 대한 위해',
    key: 'apply.symptoms.check2',
  },
  {
    label: '치료적 의료기구 제거',
    key: 'apply.symptoms.check3',
  },
  {
    label: '기타',
    key: 'apply.symptoms.check4',
  },
];

const method = [
  {
    label: '통증 / 안위 조절',
    key: 'apply.method.check0',
  },
  {
    label: '체위변경 계획',
    key: 'apply.method.check1',
  },
  {
    label: '배설 계획',
    key: 'apply.method.check2',
  },
  {
    label: '간호사실과 가까운 장소 이동',
    key: 'apply.method.check3',
  },
  {
    label: '지남력 재적응 시도',
    key: 'apply.method.check4',
  },
  {
    label: '가족/친구 방문 격려',
    key: 'apply.method.check5',
  },
  {
    label: '기타',
    key: 'apply.method.check6',
  },
];

const category = [
  {
    label: '손목 / 발목 보호대',
    key: 'apply.category.check0',
  },
  {
    label: '조끼 보호대',
    key: 'apply.category.check1',
  },
  {
    label: '벨트 보호대',
    key: 'apply.category.check2',
  },
  {
    label: '장갑 보호대',
    key: 'apply.category.check3',
  },
  {
    label: '팔꿈치 보호대',
    key: 'apply.category.check4',
  },
  {
    label: '기타',
    key: 'apply.category.check5',
  },
];

const apply = (props: Props) => {
  const {
    disabled,
    register,
    getValues,
    setValue,
    control,
    watch,
    restraintList,
    setRestraintList,
  } = props;

  return (
    <Fragment>
      <SectionTitle title="신체보호대 적용" />

      <RowContainer xs={12} sx={{ marginLeft: '-25px' }}>
        <RowContent
          title="대상자 증상 (모두 체크하시오.)"
          titleRatio={2}
          childrenRatio={10}
        >
          <Grid container xs={10}>
            {symptoms.map((v, i) => (
              <Grid item xs={4}>
                <Form.MuiCheckbox
                  label={v.label}
                  disabled={disabled}
                  defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                  onChange={(_, checked) => {
                    setValue(v.key, checked);
                    if (checked) setRestraintList([...restraintList, v.label]);
                    else
                      setRestraintList([
                        ...restraintList.filter(value => value !== v.label),
                      ]);
                  }}
                />
              </Grid>
            ))}
            <Form.MuiTextField
              required={false}
              disabled={disabled}
              placeholder="직접 입력"
              sx={{ width: '9vw', marginLeft: '-200px' }}
              {...register('apply.symptoms.input')}
            />
          </Grid>
        </RowContent>
        <RowContentPreWrap
          title="사전에 시도된 신체보호대 대안방법
(모두 체크하시오.)"
          titleRatio={2}
          childrenRatio={10}
        >
          <Grid container xs={10}>
            {method.map((v, i) => (
              <Grid item xs={4}>
                <Form.MuiCheckbox
                  label={v.label}
                  disabled={disabled}
                  defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                  onChange={(_, checked) => {
                    setValue(v.key, checked);
                    if (checked) setRestraintList([...restraintList, v.label]);
                    else
                      setRestraintList([
                        ...restraintList.filter(value => value !== v.label),
                      ]);
                  }}
                />
              </Grid>
            ))}
            <Form.MuiTextField
              required={false}
              disabled={disabled}
              placeholder="직접 입력"
              sx={{ width: '9vw', marginLeft: '-200px' }}
              {...register('apply.method.input')}
            />
          </Grid>
        </RowContentPreWrap>
        <RowContent title="주치의 처방" titleRatio={2} childrenRatio={10}>
          <Stack direction="row" spacing={3}>
            <MuiRadioGroup
              i18nKey="YESORNO"
              values={[1, 2]}
              disabled={disabled}
              defaultValue={getValues('apply.prescription.value')}
              onChange={v => {
                setValue('apply.prescription.value', v);
              }}
              // defaultValue={getValues('apply.prescription.value')}
              // onChange={v => {
              //   setValue('apply.prescription.value', v);
              // }}
              width="20.2vw"
            />
          </Stack>
        </RowContent>
        <RowContent title="신체보호대 유형" titleRatio={2} childrenRatio={10}>
          <Grid container xs={10}>
            {category.map((v, i) => (
              <Grid item xs={4}>
                <Form.MuiCheckbox
                  label={v.label}
                  disabled={disabled}
                  defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                  onChange={(_, checked) => {
                    setValue(v.key, checked);
                    if (checked) setRestraintList([...restraintList, v.label]);
                    else
                      setRestraintList([
                        ...restraintList.filter(value => value !== v.label),
                      ]);
                  }}
                />
              </Grid>
            ))}
            <Form.MuiTextField
              required={false}
              disabled={disabled}
              placeholder="직접 입력"
              sx={{ width: '9vw', marginLeft: '-200px' }}
              {...register('apply.category.input')}
            />
          </Grid>
        </RowContent>
        <RowContent
          title="대상자 / 가족 정보"
          titleRatio={2}
          childrenRatio={10}
        >
          <Stack direction="column" spacing={3}>
            <MuiRadioGroup
              i18nKey="YESORNO"
              values={[1, 2]}
              disabled={disabled}
              defaultValue={getValues('apply.information.value')}
              onChange={v => {
                setValue('apply.information.value', v);
              }}
              width="20.2vw"
            />
            <Form.MuiTextField
              fullWidth
              required={false}
              disabled={disabled}
              placeholder="“아니오”일 경우, 자세히 쓰시오"
              {...register('apply.information.input')}
              multiline
              minRows={3}
            />
          </Stack>
        </RowContent>
        <RowContent title="신체 보호대 적용" titleRatio={2} childrenRatio={10}>
          <Stack direction="row" spacing={3} width="65%">
            <Form.MuiTextField
              required={false}
              type="date"
              disabled={disabled}
              sx={{ marginRight: '20px' }}
              {...register('apply.protection_apply.date')}
            />
            <DateBoundTimePicker
              value={
                coercePickerDate(watch('apply.protection_apply.time')) || null
              }
              onChange={value => {
                setValue('apply.protection_apply.time', value);
              }}
              placeholder="00:00"
              usePortal={false}
            />
          </Stack>
        </RowContent>
        <RowContent title="종료 및 재사용" titleRatio={2} childrenRatio={10}>
          <MuiRadioGroup
            i18nKey="RESTRAINT.END"
            values={[1, 2]}
            disabled={disabled}
            defaultValue={getValues('apply.end_and_reuse.value')}
            onChange={v => {
              setValue('apply.end_and_reuse.value', v);
            }}
            width="25vw"
          />
        </RowContent>
        <RowContent title="" titleRatio={2} childrenRatio={10}>
          <Stack direction="row" spacing={3} width="65%">
            <Form.MuiTextField
              required={false}
              type="date"
              disabled={disabled}
              sx={{ marginRight: '20px' }}
              {...register('apply.end_and_reuse.date')}
            />
            <DateBoundTimePicker
              value={
                coercePickerDate(watch('apply.end_and_reuse.time')) || null
              }
              onChange={value => {
                setValue('apply.end_and_reuse.time', value);
              }}
              placeholder="00:00"
              usePortal={false}
            />
          </Stack>
        </RowContent>
      </RowContainer>
    </Fragment>
  );
};

export default apply;
